import React, { useEffect, useRef, useState } from "react";
import { Plus, X } from "lucide-react";
import { BASE_URL } from "../../../config/api";
import InputField from "../../../Component/RetailerComponents/InputField";
import SelectField from "../../../Component/RetailerComponents/SelectField";

export default function ProductModal({ isOpen, onClose, onSubmit, initialData }) {
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  // const [validity, setValidity] = useState("");
  const [validityMonths, setValidityMonths] = useState(12);
  const [claims, setClaims] = useState("");
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");
  const [marginType, setMarginType] = useState("percent");
  const [marginValue, setMarginValue] = useState("");
  const [adminmargin, setAdminMargin] = useState("");

  const [hsn, setHsn] = useState("998413");
  const [productType, setProductType] = useState("service");
  const [planType, setPlanType] = useState("Extended Warranty");

  const [labelType, setLabelType] = useState("regular");


  const [status, setStatus] = useState(1);
  const [categories, setCategories] = useState([]);
  const [selectedCats, setSelectedCats] = useState([]);

  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const [features, setFeatures] = useState("");
  const [coverage, setCoverage] = useState("");
  const [exclusions, setexclusions] = useState("");

  const [featureInput, setFeatureInput] = useState("");
  const [coverageInput, setCoverageInput] = useState("");
  const [exclusionInput, setExclusionInput] = useState("");
  const [planFeatureMessage, setPlanFeatureMessage] = useState("");

  const addItem = (value, setter, inputSetter) => {
    if (!value.trim()) return;

    setter((prev) =>
      prev ? `${prev}.${value.trim()}` : value.trim()
    );
    inputSetter("");
    // Hide message once user adds something
    setPlanFeatureMessage("");
  };

  const removeItem = (index, value, setter) => {
    const items = value.split(".");
    items.splice(index, 1);
    setter(items.join("."));
  };


  const MONTH_OPTIONS = [
  { label: "3 Months", value: 3 },
  { label: "6 Months", value: 6 },
  { label: "12 Months", value: 12 },
  { label: "18 Months", value: 18 },
  { label: "24 Months", value: 24 },
];

  const monthToDays = (months) => {
    return Math.round(months * 365 / 12);
  };
  const daysToMonth = (days) => Math.round(days / 30);

  const user = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const id = user?.id;

  const fetchCategories = async () => {
    try {
      const res = await fetch(`${BASE_URL}warranty/get-categories`);
      const data = await res.json();

      // Keep only active categories
      const activeCats = data.filter(cat => Number(cat.status) === 1);

      setCategories(activeCats);
    } catch (err) {
      console.log(err);
    }
  };


  // useEffect(() => {
  //   fetchCategories();

  //   if (initialData) {
  //     setName(initialData.name || "");
  //     setImage(initialData.image || "");
  //     // setValidity(initialData.validity || "");
  //     setValidityMonths(
  //       initialData.validity
  //         ? daysToMonth(initialData.validity)
  //         : 12
  //     );
  //     setClaims(initialData.claims || "");
  //     setFeatures(initialData.features || "");
  //     setMinValue(initialData.min_value || "");
  //     setMaxValue(initialData.max_value || "");
  //     setAdminMargin(initialData.margin || "");
  //     setCoverage(initialData.coverage || "");
  //     setexclusions(initialData.exclusions || "");


  //     if (initialData.is_percent == 1) {
  //       setMarginType("percent");
  //     } else {
  //       setMarginType("mrp");
  //     }
  //     setMarginValue(initialData.mrp || "");

  //     setLabelType(initialData.is_regular ? "regular" : "offer");

  //     setHsn(initialData.hsn_code || "998413");
  //     setProductType(initialData.product_type || "service");
  //     setPlanType(initialData.product_type || "Extended Warranty");
  //     setStatus(initialData.status || 1);

  //     const categoryIds = initialData.categories
  //       ? initialData.categories.map((c) => c.id)
  //       : [];
  //     setSelectedCats(categoryIds);
  //   } else {
  //     setName("");
  //     setImage("");
  //     setValidityMonths(12);
  //     setClaims("");
  //     setMinValue("");
  //     setMaxValue("");
  //     setFeatures("");
  //     setMarginValue("");
  //     setMarginType("percent");
  //     setLabelType("regular");
  //     setSelectedCats([]);
  //     setAdminMargin("");
  //   }
  // }, [initialData]);

  useEffect(() => {
  if (!isOpen) return; // only run when modal opens

  fetchCategories();

  if (initialData) {
    // UPDATE MODE
    setName(initialData.name || "");
    setImage(initialData.image || "");
    setValidityMonths(
      initialData.validity
        ? daysToMonth(initialData.validity)
        : 12
    );
    setClaims(initialData.claims || "");
    setFeatures(initialData.features || "");
    setMinValue(initialData.min_value || "");
    setMaxValue(initialData.max_value || "");
    setAdminMargin(initialData.margin || "");
    setCoverage(initialData.coverage || "");
    setexclusions(initialData.exclusions || "");

    setMarginType(initialData.is_percent == 1 ? "percent" : "mrp");
    setMarginValue(initialData.mrp || "");
    setLabelType(initialData.is_regular ? "regular" : "offer");
    setHsn(initialData.hsn_code || "998413");
    setProductType(initialData.product_type || "service");
    setPlanType(initialData.plan_type || "Extended Warranty");
    setStatus(initialData.status || 1);

    const categoryIds = initialData.categories
      ? initialData.categories.map((c) => c.id)
      : [];
    setSelectedCats(categoryIds);

  } else {
    // CREATE MODE
    resetForm();
    fetchPlanFeatures(planType); // 👈 NOW IT WILL RUN
  }

}, [initialData, isOpen]);

const handlePlanChange = (value) => {
  setPlanType(value);
  fetchPlanFeatures(value);
};

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadLoading(true);

    const form = new FormData();
    form.append("file", file);
    form.append("tag", "Product");

    try {
      const res = await fetch(`${BASE_URL}warranty/upload-file`, {
        method: "POST",
        body: form,
      });

      const data = await res.json();
      if (data?.data?.file_url) setImage(data.data.file_url);
    } catch (err) {
      alert("Image upload failed");
    } finally {
      setUploadLoading(false);
    }
  };

  const fetchPlanFeatures = async (selectedPlanType) => {
  try {
    const res = await fetch(
      `${BASE_URL}warranty/get-features?product_type=${encodeURIComponent(selectedPlanType)}`
    );

    const result = await res.json();

    if (result?.status && result?.data?.length > 0) {
      const apiData = result.data[0];

      setFeatures(apiData.features || "");
      setCoverage(apiData.coverage || "");
      setexclusions(apiData.exclusions || "");

      setPlanFeatureMessage(""); // clear message
    } else {
      // CLEAR PREVIOUS DATA
      setFeatures("");
      setCoverage("");
      setexclusions("");

      setPlanFeatureMessage(
        "No features, coverage and exclusions found for selected type. Please add them to create."
      );
    }
  } catch (err) {
    console.log("Failed to fetch plan features", err);
  }
};

  const toggleCategory = (id) => {
    setSelectedCats((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]
    );
  };

  const addFeature = () => {
    if (!featureInput.trim()) return;

    setFeatures((prev) =>
      prev ? `${prev}, ${featureInput.trim()}` : featureInput.trim()
    );

    setFeatureInput("");
  };

  const removeFeature = (index) => {
    const list = features.split(",").map(f => f.trim());
    list.splice(index, 1);
    setFeatures(list.join(", "));
  };


  const resetForm = () => {
  setName("");
  setImage("");
  setValidityMonths(12);
  setClaims("");
  setMinValue("");
  setMaxValue("");
  setMarginType("percent");
  setMarginValue("");
  setAdminMargin("");
  setHsn("998413");
  setProductType("service");
  setLabelType("regular");
  setStatus(1);
  setSelectedCats([]);
  setFeatures("");
  setCoverage("");
  setexclusions("");
  setFeatureInput("");
  setCoverageInput("");
  setExclusionInput("");
};


  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    const selectedCategoryNames = categories
    .filter((cat) => selectedCats.includes(cat.id))
    .map((cat) => cat.name)
    .join(", ");

    const payload = {
      // name,
      plan_type: planType,
      image,
      validity: monthToDays(validityMonths),
      claims: Number(claims),
      features,
      min_value: Number(minValue),
      max_value: Number(maxValue),
      margin: Number(adminmargin), 
      is_fixed: marginType === "mrp" ? 1 : 0,
      is_percent: marginType === "percent" ? 1 : 0,
      is_regular: labelType === "regular" ? 1 : 0,
      is_offer: labelType === "offer" ? 1 : 0,
      is_taxable: true,
      product_type: productType,
      hsn_or_sac: hsn,
      mrp: Number(marginValue),
      status: Number(status),
      category_ids: selectedCats,
      category_name: selectedCategoryNames,
      company_id: id,
      coverage,
      exclusions,
    };

    try {
      let url = "";

      if (initialData?.id) {
        url = `${BASE_URL}warranty/update-product/${initialData.id}`;
      } else {
        url = `${BASE_URL}warranty/create-product`;
      }

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to save product");

      resetForm();
      onSubmit();
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white w-[1000px] max-h-[90vh] overflow-y-auto rounded-xl p-4 relative">

        <button className="absolute top-3 right-3" onClick={() => {
            resetForm();
            onClose();
          }}>
          <X size={20} />
        </button>

        <h2 className="text-lg font-semibold mb-4">
          {initialData ? "Update Product" : "Add Product"}
        </h2>

        <form onSubmit={handleSave} className="grid grid-cols-3 gap-5">

          {/* COLUMN 1 */}
          <div className="space-y-4">
            <div>
              {/* <SelectField
                label="Product Type"
                value={planType}
                required
                onChange={(value) => setPlanType(value)}
                options={[
                  { label: "Extended Warranty", value: "Extended Warranty" },
                  { label: "Total Protection", value: "Total Protection" },
                  { label: "Screen Damage", value: "Screen Damage" },
                ]}
              /> */}

              <SelectField
                label="Product Type"
                value={planType}
                required
                onChange={handlePlanChange}
                options={[
                  { label: "Extended Warranty", value: "Extended Warranty" },
                  { label: "Total Protection", value: "Total Protection" },
                  { label: "Screen Damage", value: "Screen Damage" },
                ]}
              />
            </div>

            <div>
              {/* <InputField  label= "Expiry Days" required type="number" className="w-full border px-3 py-2 rounded"
                value={validity} onChange={(value) => setValidity(value)} /> */}

              <SelectField
                label="Expiry Period"
                required
                value={validityMonths}
                onChange={(value) => setValidityMonths(Number(value))}
                options={MONTH_OPTIONS}
              />
            </div>

            <div>
              <InputField
                label={marginType === "percent" ? "Admin Margin (%)" : "Admin Margin (₹)"}
                required
                type="number"
                className="w-full border px-3 py-2 rounded"
                value={adminmargin}
                onChange={(value) => setAdminMargin(value)}
              />
            </div>


            <div>
              <InputField label="Number of Claims" required type="number" className="w-full border px-3 py-2 rounded"
                value={claims} onChange={(value) => setClaims(value)} />
            </div>

            <div>
              <InputField label="HSN / SAC" required className="w-full border px-3 py-2 rounded bg-gray-100"
                value={hsn} disabled />
            </div>
          </div>

          {/* COLUMN 2 */}
          <div className="space-y-4">

            <div>
              <InputField label="Min Value" required type="number" className="w-full border px-3 py-2 rounded"
                value={minValue} onChange={(value) => setMinValue(value)} />
            </div>
            
            <div>
              {/* <label className="text-sm font-medium">Margin Type</label> */}
                <SelectField
                  label="Margin Type"
                  value={marginType}
                  onChange={(value) => setMarginType(value)}
                  required
                  options={[
                    { label: "Percent", value: "percent" },
                    { label: "MRP", value: "mrp" },
                  ]}
                />
            </div>

            <div>
              {/* <label className="text-sm font-medium">Status</label> */}
              <SelectField
                label="Status"
                value={status}
                required
                onChange={(value) => setStatus(value)}
                options={[
                    { label: "Active", value: 1 },
                    { label: "Inactive", value: 0 },
                  ]}
              />
            </div>

            <div>
              <InputField label="Product Type" required className="w-full border px-3 py-2 rounded bg-gray-100"
                value="Service" disabled />
            </div>

            <div className="col-span-3">
            <p className="text-sm mb-1 font-medium">Product Category</p>

            <div className="flex flex-wrap gap-2 mt-2">
              {categories.map((c) => {
                const isSelected = selectedCats.includes(c.id);

                return (
                  <span
                    key={c.id}
                    onClick={() => toggleCategory(c.id)}
                    className={`px-3 py-1.5 text-xs rounded-full cursor-pointer border select-none transition
                      ${isSelected 
                        ? "bg-blue-600 text-white border-blue-600" 
                        : "bg-slate-100 text-slate-600 border-slate-300 hover:bg-slate-200"
                      }`}
                  >
                    {c.name}
                  </span>
                );
              })}
            </div>
          </div>
          </div>

          {/* COLUMN 3 */}
          <div className="space-y-4">

            <div>
              <InputField label="Max Value" required type="number" className="w-full border px-3 py-2 rounded"
                value={maxValue} onChange={(value) => setMaxValue(value)} />
            </div>

            <div>
              <InputField label={marginType === "percent" ? "Margin (%)" : "Margin (MRP)"} required type="number" className="w-full border px-3 py-2 rounded"
                value={marginValue} onChange={(value) => setMarginValue(value)} />
            </div>

            <div>
              <SelectField
                label="Label Type"
                value={labelType} 
                onChange={(value) => setLabelType(value)}
                required
                options={[
                    { label: "Regular", value: "regular" },
                    { label: "Offer", value: "offer" },
                  ]}
                />
            </div>

            <div>
              <InputField label="Upload Image" required type="file" onChange={handleImageUpload} />
              {image && <img src={image} className="w-20 h-20 mt-2 border rounded" />}
              {uploadLoading && <p className="text-xs text-gray-500">Uploading...</p>}
            </div>
          </div>

          {/* FULL WIDTH SECTIONS */}
          <div className="col-span-3">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

              {/* FEATURES */}
              <div>
                <label className="text-sm font-medium">Product Features</label>

                <div className="relative mt-1">
                  <input
                    value={featureInput}
                    onChange={(e) => setFeatureInput(e.target.value)}
                    placeholder="Type feature and press +"
                    className="w-full border px-3 py-2 pr-10 rounded"
                  />

                  <button
                    type="button"
                    onClick={() =>
                      addItem(featureInput, setFeatures, setFeatureInput)
                    }
                    className="absolute right-2 top-1/2 -translate-y-1/2
                              p-1.5 rounded bg-blue-600 text-white
                              hover:bg-blue-700 disabled:opacity-50"
                    disabled={!featureInput.trim()}
                    title="Add feature"
                  >
                    <Plus size={16} />
                  </button>
                </div>

                {planFeatureMessage && (
                  <div className="mt-4 p-3 rounded-md bg-amber-50 border border-amber-200 text-amber-700 text-sm">
                    {planFeatureMessage}
                  </div>
                )}


                <div className="flex flex-wrap gap-2 mt-3">
                  {features &&
                    features.split(".").map((f, i) => (
                      <Chip
                        key={i}
                        label={f}
                        onRemove={() => removeItem(i, features, setFeatures)}
                      />
                    ))}
                </div>
              </div>

              {/* COVERAGE */}
              <div>
                <label className="text-sm font-medium">Coverage</label>

                  <div className="relative mt-1">
                    <input
                      value={coverageInput}
                      onChange={(e) => setCoverageInput(e.target.value)}
                      placeholder="Type coverage and press +"
                      className="w-full border px-3 py-2 pr-10 rounded"
                    />

                    <button
                      type="button"
                      onClick={() =>
                        addItem(coverageInput, setCoverage, setCoverageInput)
                      }
                      className="absolute right-2 top-1/2 -translate-y-1/2
                                p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700"
                      disabled={!coverageInput.trim()}
                    >
                      <Plus size={16} />
                    </button>
                  </div>

                <div className="flex flex-wrap gap-2 mt-3">
                  {coverage &&
                    coverage.split(".").map((c, i) => (
                      <Chip
                        key={i}
                        label={c}
                        onRemove={() => removeItem(i, coverage, setCoverage)}
                      />
                    ))}
                </div>
              </div>

              {/* exclusions */}
              <div>
                <label className="text-sm font-medium">exclusions</label>

                <div className="relative mt-1">
                  <input
                    value={exclusionInput}
                    onChange={(e) => setExclusionInput(e.target.value)}
                    placeholder="Type exclusion and press +"
                    className="w-full border px-3 py-2 pr-10 rounded"
                  />

                  <button
                    type="button"
                    onClick={() =>
                      addItem(exclusionInput, setexclusions, setExclusionInput)
                    }
                    disabled={!exclusionInput.trim()}
                    className="absolute right-2 top-1/2 -translate-y-1/2
                              p-1.5 rounded bg-blue-600 text-white
                              hover:bg-blue-700 disabled:opacity-50"
                    title="Add exclusion"
                  >
                    <Plus size={16} />
                  </button>
                </div>


                <div className="flex flex-wrap gap-2 mt-3">
                  {exclusions &&
                    exclusions.split(".").map((e, i) => (
                      <Chip
                        key={i}
                        label={e}
                        onRemove={() => removeItem(i, exclusions, setexclusions)}
                      />
                    ))}
                </div>
              </div>

            </div>
          </div>

          <div className="flex justify-end col-span-3">
            <button
              type="submit"
              className="w-[200px] bg-blue-600 text-white py-2 rounded"
              disabled={loading}
            >
              {loading ? "Saving..." : initialData ? "Update Product" : "Add Product"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

const Chip = ({ label, onRemove }) => (
  <div className="flex items-center gap-2 bg-slate-100 border rounded-full px-3 py-1 text-sm">
    <span>{label}</span>
    <button
      type="button"
      onClick={onRemove}
      className="text-slate-500 hover:text-red-500"
    >
      ✕
    </button>
  </div>
);


// import React, { useEffect, useState } from "react";
// import { Plus, X } from "lucide-react";
// import { BASE_URL } from "../../../config/api";
// import InputField from "../../../Component/RetailerComponents/InputField";
// import SelectField from "../../../Component/RetailerComponents/SelectField";

// export default function ProductModal({ isOpen, onClose, onSubmit, initialData }) {
//   const [name, setName] = useState("");
//   const [image, setImage] = useState("");
//   const [validity, setValidity] = useState("");
//   const [claims, setClaims] = useState("");
//   const [minValue, setMinValue] = useState("");
//   const [maxValue, setMaxValue] = useState("");
//   const [marginType, setMarginType] = useState("percent");
//   const [marginValue, setMarginValue] = useState("");
//   const [adminmargin, setAdminMargin] = useState("");

//   const [hsn, setHsn] = useState("998413");
//   const [productType, setProductType] = useState("service");

//   const [labelType, setLabelType] = useState("regular");


//   const [status, setStatus] = useState(1);
//   const [categories, setCategories] = useState([]);
//   const [selectedCats, setSelectedCats] = useState([]);

//   const [loading, setLoading] = useState(false);
//   const [uploadLoading, setUploadLoading] = useState(false);

//   const [features, setFeatures] = useState("");
//   const [coverage, setCoverage] = useState("");
//   const [exclusions, setexclusions] = useState("");

//   const [featureInput, setFeatureInput] = useState("");
//   const [coverageInput, setCoverageInput] = useState("");
//   const [exclusionInput, setExclusionInput] = useState("");

//   const addItem = (value, setter, inputSetter) => {
//     if (!value.trim()) return;

//     setter((prev) =>
//       prev ? `${prev}.${value.trim()}` : value.trim()
//     );
//     inputSetter("");
//   };

//   const removeItem = (index, value, setter) => {
//     const items = value.split(".");
//     items.splice(index, 1);
//     setter(items.join("."));
//   };

//    const user = JSON.parse(localStorage.getItem("authUserData") || "{}");
//    const id = user?.id;

//   const fetchCategories = async () => {
//     try {
//       const res = await fetch(`${BASE_URL}warranty/get-categories`);
//       const data = await res.json();

//       // Keep only active categories
//       const activeCats = data.filter(cat => Number(cat.status) === 1);

//       setCategories(activeCats);
//     } catch (err) {
//       console.log(err);
//     }
//   };


//   useEffect(() => {
//     fetchCategories();

//     if (initialData) {
//       setName(initialData.name || "");
//       setImage(initialData.image || "");
//       setValidity(initialData.validity || "");
//       setClaims(initialData.claims || "");
//       setFeatures(initialData.features || "");
//       setMinValue(initialData.min_value || "");
//       setMaxValue(initialData.max_value || "");
//       setAdminMargin(initialData.margin || "");
//       setCoverage(initialData.coverage || "");
//       setexclusions(initialData.exclusions || "");


//       if (initialData.is_percent == 1) {
//         setMarginType("percent");
//       } else {
//         setMarginType("mrp");
//       }
//       setMarginValue(initialData.mrp || "");

//       setLabelType(initialData.is_regular ? "regular" : "offer");

//       setHsn(initialData.hsn_code || "998413");
//       setProductType(initialData.product_type || "service");
//       setStatus(initialData.status || 1);

//       const categoryIds = initialData.categories
//         ? initialData.categories.map((c) => c.id)
//         : [];
//       setSelectedCats(categoryIds);
//     } else {
//       setName("");
//       setImage("");
//       setValidity("");
//       setClaims("");
//       setMinValue("");
//       setMaxValue("");
//       setFeatures("");
//       setMarginValue("");
//       setMarginType("percent");
//       setLabelType("regular");
//       setSelectedCats([]);
//       setAdminMargin("");
//     }
//   }, [initialData]);

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploadLoading(true);

//     const form = new FormData();
//     form.append("file", file);
//     form.append("tag", "Product");

//     try {
//       const res = await fetch(`${BASE_URL}warranty/upload-file`, {
//         method: "POST",
//         body: form,
//       });

//       const data = await res.json();
//       if (data?.data?.file_url) setImage(data.data.file_url);
//     } catch (err) {
//       alert("Image upload failed");
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   const toggleCategory = (id) => {
//     setSelectedCats((prev) =>
//       prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]
//     );
//   };

//   const addFeature = () => {
//     if (!featureInput.trim()) return;

//     setFeatures((prev) =>
//       prev ? `${prev}, ${featureInput.trim()}` : featureInput.trim()
//     );

//     setFeatureInput("");
//   };

//   const removeFeature = (index) => {
//     const list = features.split(",").map(f => f.trim());
//     list.splice(index, 1);
//     setFeatures(list.join(", "));
//   };


//   const resetForm = () => {
//   setName("");
//   setImage("");
//   setValidity("");
//   setClaims("");
//   setMinValue("");
//   setMaxValue("");
//   setMarginType("percent");
//   setMarginValue("");
//   setAdminMargin("");
//   setHsn("998413");
//   setProductType("service");
//   setLabelType("regular");
//   setStatus(1);
//   setSelectedCats([]);
//   setFeatures("");
//   setCoverage("");
//   setexclusions("");
//   setFeatureInput("");
//   setCoverageInput("");
//   setExclusionInput("");
// };


//   const handleSave = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const payload = {
//       name,
//       image,
//       validity: Number(validity),
//       claims: Number(claims),
//       features,
//       min_value: Number(minValue),
//       max_value: Number(maxValue),
//       margin: Number(adminmargin), 
//       is_fixed: marginType === "mrp" ? 1 : 0,
//       is_percent: marginType === "percent" ? 1 : 0,
//       is_regular: labelType === "regular" ? 1 : 0,
//       is_offer: labelType === "offer" ? 1 : 0,
//       is_taxable: true,
//       product_type: productType,
//       hsn_or_sac: hsn,
//       mrp: Number(marginValue),
//       status: Number(status),
//       category_ids: selectedCats,
//       company_id: id,
//       coverage,
//       exclusions,
//     };

//     try {
//       let url = "";

//       if (initialData?.id) {
//         url = `${BASE_URL}warranty/update-product/${initialData.id}`;
//       } else {
//         url = `${BASE_URL}warranty/create-product`;
//       }

//       const res = await fetch(url, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) throw new Error("Failed to save product");

//       resetForm();
//       onSubmit();
//     } catch (err) {
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
//       <div className="bg-white w-[1000px] max-h-[90vh] overflow-y-auto rounded-xl p-4 relative">

//         <button className="absolute top-3 right-3" onClick={() => {
//             resetForm();
//             onClose();
//           }}>
//           <X size={20} />
//         </button>

//         <h2 className="text-lg font-semibold mb-4">
//           {initialData ? "Update Product" : "Add Product"}
//         </h2>

//         <form onSubmit={handleSave} className="grid grid-cols-3 gap-5">

//           {/* COLUMN 1 */}
//           <div className="space-y-4">
//             <div>
//               <InputField label="Product Name" required type="text" className="w-full border px-3 py-2 rounded"
//                 value={name} onChange={(value) => setName(value)}  />
//             </div>

//             <div>
//               <InputField  label= "Expiry Days" required type="number" className="w-full border px-3 py-2 rounded"
//                 value={validity} onChange={(value) => setValidity(value)} />
//             </div>

//             <div>
//               <InputField
//                 label={marginType === "percent" ? "Admin Margin (%)" : "Admin Margin (₹)"}
//                 required
//                 type="number"
//                 className="w-full border px-3 py-2 rounded"
//                 value={adminmargin}
//                 onChange={(value) => setAdminMargin(value)}
//               />
//             </div>


//             <div>
//               <InputField label="Number of Claims" required type="number" className="w-full border px-3 py-2 rounded"
//                 value={claims} onChange={(value) => setClaims(value)} />
//             </div>

//             <div>
//               <InputField label="HSN / SAC" required className="w-full border px-3 py-2 rounded bg-gray-100"
//                 value={hsn} disabled />
//             </div>
//           </div>

//           {/* COLUMN 2 */}
//           <div className="space-y-4">

//             <div>
//               <InputField label="Min Value" required type="number" className="w-full border px-3 py-2 rounded"
//                 value={minValue} onChange={(value) => setMinValue(value)} />
//             </div>
            
//             <div>
//               {/* <label className="text-sm font-medium">Margin Type</label> */}
//                 <SelectField
//                   label="Margin Type"
//                   value={marginType}
//                   onChange={(value) => setMarginType(value)}
//                   required
//                   options={[
//                     { label: "Percent", value: "percent" },
//                     { label: "MRP", value: "mrp" },
//                   ]}
//                 />
//             </div>

//             <div>
//               {/* <label className="text-sm font-medium">Status</label> */}
//               <SelectField
//                 label="Status"
//                 value={status}
//                 required
//                 onChange={(value) => setStatus(value)}
//                 options={[
//                     { label: "Active", value: 1 },
//                     { label: "Inactive", value: 0 },
//                   ]}
//               />
//             </div>

//             <div>
//               <InputField label="Product Type" required className="w-full border px-3 py-2 rounded bg-gray-100"
//                 value="Service" disabled />
//             </div>

//             <div className="col-span-3">
//             <p className="text-sm mb-1 font-medium">Product Category</p>

//             <div className="flex flex-wrap gap-2 mt-2">
//               {categories.map((c) => {
//                 const isSelected = selectedCats.includes(c.id);

//                 return (
//                   <span
//                     key={c.id}
//                     onClick={() => toggleCategory(c.id)}
//                     className={`px-3 py-1.5 text-xs rounded-full cursor-pointer border select-none transition
//                       ${isSelected 
//                         ? "bg-blue-600 text-white border-blue-600" 
//                         : "bg-slate-100 text-slate-600 border-slate-300 hover:bg-slate-200"
//                       }`}
//                   >
//                     {c.name}
//                   </span>
//                 );
//               })}
//             </div>
//           </div>
//           </div>

//           {/* COLUMN 3 */}
//           <div className="space-y-4">

//             <div>
//               <InputField label="Max Value" required type="number" className="w-full border px-3 py-2 rounded"
//                 value={maxValue} onChange={(value) => setMaxValue(value)} />
//             </div>

//             <div>
//               <InputField label={marginType === "percent" ? "Margin (%)" : "Margin (MRP)"} required type="number" className="w-full border px-3 py-2 rounded"
//                 value={marginValue} onChange={(value) => setMarginValue(value)} />
//             </div>

//             <div>
//               <SelectField
//                 label="Label Type"
//                 value={labelType} 
//                 onChange={(value) => setLabelType(value)}
//                 required
//                 options={[
//                     { label: "Regular", value: "regular" },
//                     { label: "Offer", value: "offer" },
//                   ]}
//                 />
//             </div>

//             <div>
//               <InputField label="Upload Image" required type="file" onChange={handleImageUpload} />
//               {image && <img src={image} className="w-20 h-20 mt-2 border rounded" />}
//               {uploadLoading && <p className="text-xs text-gray-500">Uploading...</p>}
//             </div>
//           </div>

//           {/* FULL WIDTH SECTIONS */}
//           <div className="col-span-3">
//             <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

//               {/* FEATURES */}
//               <div>
//                 <label className="text-sm font-medium">Product Features</label>

//                 <div className="relative mt-1">
//                   <input
//                     value={featureInput}
//                     onChange={(e) => setFeatureInput(e.target.value)}
//                     placeholder="Type feature and press +"
//                     className="w-full border px-3 py-2 pr-10 rounded"
//                   />

//                   <button
//                     type="button"
//                     onClick={() =>
//                       addItem(featureInput, setFeatures, setFeatureInput)
//                     }
//                     className="absolute right-2 top-1/2 -translate-y-1/2
//                               p-1.5 rounded bg-blue-600 text-white
//                               hover:bg-blue-700 disabled:opacity-50"
//                     disabled={!featureInput.trim()}
//                     title="Add feature"
//                   >
//                     <Plus size={16} />
//                   </button>
//                 </div>


//                 <div className="flex flex-wrap gap-2 mt-3">
//                   {features &&
//                     features.split(".").map((f, i) => (
//                       <Chip
//                         key={i}
//                         label={f}
//                         onRemove={() => removeItem(i, features, setFeatures)}
//                       />
//                     ))}
//                 </div>
//               </div>

//               {/* COVERAGE */}
//               <div>
//                 <label className="text-sm font-medium">Coverage</label>

//                   <div className="relative mt-1">
//                     <input
//                       value={coverageInput}
//                       onChange={(e) => setCoverageInput(e.target.value)}
//                       placeholder="Type coverage and press +"
//                       className="w-full border px-3 py-2 pr-10 rounded"
//                     />

//                     <button
//                       type="button"
//                       onClick={() =>
//                         addItem(coverageInput, setCoverage, setCoverageInput)
//                       }
//                       className="absolute right-2 top-1/2 -translate-y-1/2
//                                 p-1.5 rounded bg-blue-600 text-white hover:bg-blue-700"
//                       disabled={!coverageInput.trim()}
//                     >
//                       <Plus size={16} />
//                     </button>
//                   </div>

//                 <div className="flex flex-wrap gap-2 mt-3">
//                   {coverage &&
//                     coverage.split(".").map((c, i) => (
//                       <Chip
//                         key={i}
//                         label={c}
//                         onRemove={() => removeItem(i, coverage, setCoverage)}
//                       />
//                     ))}
//                 </div>
//               </div>

//               {/* exclusions */}
//               <div>
//                 <label className="text-sm font-medium">exclusions</label>

//                 <div className="relative mt-1">
//                   <input
//                     value={exclusionInput}
//                     onChange={(e) => setExclusionInput(e.target.value)}
//                     placeholder="Type exclusion and press +"
//                     className="w-full border px-3 py-2 pr-10 rounded"
//                   />

//                   <button
//                     type="button"
//                     onClick={() =>
//                       addItem(exclusionInput, setexclusions, setExclusionInput)
//                     }
//                     disabled={!exclusionInput.trim()}
//                     className="absolute right-2 top-1/2 -translate-y-1/2
//                               p-1.5 rounded bg-blue-600 text-white
//                               hover:bg-blue-700 disabled:opacity-50"
//                     title="Add exclusion"
//                   >
//                     <Plus size={16} />
//                   </button>
//                 </div>


//                 <div className="flex flex-wrap gap-2 mt-3">
//                   {exclusions &&
//                     exclusions.split(".").map((e, i) => (
//                       <Chip
//                         key={i}
//                         label={e}
//                         onRemove={() => removeItem(i, exclusions, setexclusions)}
//                       />
//                     ))}
//                 </div>
//               </div>

//             </div>
//           </div>



//           <div className="flex justify-end col-span-3">
//             <button
//               type="submit"
//               className="w-[200px] bg-blue-600 text-white py-2 rounded"
//               disabled={loading}
//             >
//               {loading ? "Saving..." : initialData ? "Update Product" : "Add Product"}
//             </button>
//           </div>

//         </form>
//       </div>
//     </div>
//   );
// }

// const Chip = ({ label, onRemove }) => (
//   <div className="flex items-center gap-2 bg-slate-100 border rounded-full px-3 py-1 text-sm">
//     <span>{label}</span>
//     <button
//       type="button"
//       onClick={onRemove}
//       className="text-slate-500 hover:text-red-500"
//     >
//       ✕
//     </button>
//   </div>
// );



// import React, { useEffect, useState } from "react";
// import { X } from "lucide-react";

// export default function ProductModal({
//   isOpen,
//   onClose,
//   onSubmit,
//   initialData,
// }) {
//   const [name, setName] = useState("");
//   const [expiry, setExpiry] = useState("");
//   const [claims, setClaims] = useState("");
//   const [minValue, setMinValue] = useState("");
//   const [maxValue, setMaxValue] = useState("");
//   const [marginType, setMarginType] = useState("percent"); // percent | mrp
//   const [margin, setMargin] = useState("");
//   const [hsn, setHsn] = useState("998413");
//   const [productType, setProductType] = useState("service");
//   const [labelType, setLabelType] = useState("regular"); // offer | regular
//   const [status, setStatus] = useState(1);
//   const [description, setDescription] = useState("");

//   const [image, setImage] = useState("");
//   const [uploadLoading, setUploadLoading] = useState(false);

//   const [categories, setCategories] = useState([]);
//   const [selectedCats, setSelectedCats] = useState([]);

//   const [loading, setLoading] = useState(false);

//   // ---------------- FETCH CATEGORY LIST ----------------
//   const fetchCategories = async () => {
//     try {
//       const res = await fetch(
//         "https://goelectronix.in/api/v1/warranty/get-categories"
//       );
//       const data = await res.json();
//       setCategories(data.filter((x) => x.status === 1)); // only active
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // ---------------- PREFILL FOR UPDATE ----------------
//   useEffect(() => {
//     fetchCategories();

//     if (initialData) {
//       setName(initialData.name || "");
//       setExpiry(initialData.validity || "");
//       setClaims(initialData.claims || "");
//       setMinValue(initialData.min_value || "");
//       setMaxValue(initialData.max_value || "");
//       setMargin(initialData.mrp || "");
//       setMarginType(initialData.is_percent ? "percent" : "mrp");
//       setProductType(initialData.product_type || "service");
//       setLabelType(initialData.is_offer ? "offer" : "regular");
//       setHsn(initialData.hsn_or_sac || "998413");
//       setImage(initialData.image || "");
//       setStatus(initialData.status || 1);
//       setDescription(initialData.features || "");
//       setSelectedCats(initialData.category_ids || []);
//     } else {
//       setName("");
//       setExpiry("");
//       setClaims("");
//       setMinValue("");
//       setMaxValue("");
//       setMargin("");
//       setMarginType("percent");
//       setProductType("service");
//       setLabelType("regular");
//       setHsn("998413");
//       setImage("");
//       setStatus(1);
//       setDescription("");
//       setSelectedCats([]);
//     }
//   }, [initialData]);

//   if (!isOpen) return null;

//   // ---------------- IMAGE UPLOAD ----------------
//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploadLoading(true);

//     const form = new FormData();
//     form.append("file", file);
//     form.append("tag", "Product");

//     try {
//       const res = await fetch(
//         "https://goelectronix.in/api/v1/warranty/upload-file",
//         {
//           method: "POST",
//           body: form,
//         }
//       );

//       const data = await res.json();
//       if (data?.data?.file_url) setImage(data.data.file_url);
//     } catch (err) {
//       alert("Image upload failed");
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   // ---------------- CATEGORY TOGGLE ----------------
//   const toggleCategory = (id) => {
//     if (selectedCats.includes(id)) {
//       setSelectedCats(selectedCats.filter((c) => c !== id));
//     } else {
//       setSelectedCats([...selectedCats, id]);
//     }
//   };

//   // ---------------- SUBMIT HANDLER ----------------
//   const handleSave = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const payload = {
//       name,
//       image,
//       validity: Number(expiry),
//       claims: Number(claims),
//       min_value: Number(minValue),
//       max_value: Number(maxValue),
//       is_percent: marginType === "percent",
//       is_fixed: marginType === "mrp",
//       mrp: Number(margin),
//       hsn_or_sac: hsn,
//       features: description,
//       product_type: productType,
//       is_offer: labelType === "offer",
//       is_regular: labelType === "regular",
//       is_taxable: true,
//       status: Number(status),
//       category_ids: selectedCats,
//       company_id: 5865,
//     };

//     try {
//       let url = "";
//       let method = "POST";

//       if (initialData?.id) {
//         url = `https://goelectronix.in/api/v1/warranty/update-product/${initialData.id}`;
//       } else {
//         url = "https://goelectronix.in/api/v1/warranty/create-product";
//       }

//       const res = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) throw new Error("Failed to save product");

//       onSubmit();
//     } catch (err) {
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
//       <div className="bg-white w-[900px] max-h-[90vh] overflow-y-auto rounded-xl p-6 relative">
//         <button className="absolute top-3 right-3" onClick={onClose}>
//           <X size={20} />
//         </button>

//         <h2 className="text-lg font-semibold mb-4">
//           {initialData ? "Update Product" : "Add Product"}
//         </h2>

//         <form onSubmit={handleSave} className="space-y-4">
//           {/* 2-Column Grid */}
//           <div className="grid grid-cols-3 gap-4">

//             {/* Product Name */}
//             <div className="col-span-2">
//               <label className="text-sm font-medium">Product Name</label>
//               <input
//                 className="w-full border px-3 py-2 rounded mt-1"
//                 placeholder="Product Name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 required
//               />
//             </div>

//             {/* Expiry */}
//             <div>
//               <label className="text-sm font-medium">Expiry (Days)</label>
//               <input
//                 type="number"
//                 placeholder="Expiry Days"
//                 className="w-full border px-3 py-2 rounded mt-1"
//                 value={expiry}
//                 onChange={(e) => setExpiry(e.target.value)}
//               />
//             </div>

//             {/* Claims */}
//             <div>
//               <label className="text-sm font-medium">Number of Claims</label>
//               <input
//                 type="number"
//                 placeholder="Claims"
//                 className="w-full border px-3 py-2 rounded mt-1"
//                 value={claims}
//                 onChange={(e) => setClaims(e.target.value)}
//               />
//             </div>

//             {/* Min Value */}
//             <div>
//               <label className="text-sm font-medium">Min Value</label>
//               <input
//                 type="number"
//                 placeholder="Min Value"
//                 className="w-full border px-3 py-2 rounded mt-1"
//                 value={minValue}
//                 onChange={(e) => setMinValue(e.target.value)}
//               />
//             </div>

//             {/* Max Value */}
//             <div>
//               <label className="text-sm font-medium">Max Value</label>
//               <input
//                 type="number"
//                 placeholder="Max Value"
//                 className="w-full border px-3 py-2 rounded mt-1"
//                 value={maxValue}
//                 onChange={(e) => setMaxValue(e.target.value)}
//               />
//             </div>

//             {/* Margin Type */}
//             <div>
//               <label className="text-sm font-medium">Margin Type</label>
//               <select
//                 value={marginType}
//                 onChange={(e) => setMarginType(e.target.value)}
//                 className="w-full border px-3 py-2 rounded mt-1"
//               >
//                 <option value="percent">Percent</option>
//                 <option value="mrp">MRP</option>
//               </select>
//             </div>

//             {/* Margin Value */}
//             <div>
//               <label className="text-sm font-medium">
//                 {marginType === "percent" ? "Margin (%)" : "Margin (MRP)"}
//               </label>
//               <input
//                 type="number"
//                 placeholder={marginType === "percent" ? "Margin (%)" : "Margin (MRP)"}
//                 className="w-full border px-3 py-2 rounded mt-1"
//                 value={margin}
//                 onChange={(e) => setMargin(e.target.value)}
//               />
//             </div>

//             {/* HSN Code */}
//             <div>
//               <label className="text-sm font-medium">HSN / SAC</label>
//               <input
//                 className="w-full border px-3 py-2 rounded mt-1 bg-gray-100"
//                 value={hsn}
//                 disabled
//               />
//             </div>

//             {/* Label Type */}
//             <div>
//               <label className="text-sm font-medium">Label Type</label>
//               <select
//                 value={labelType}
//                 onChange={(e) => setLabelType(e.target.value)}
//                 className="w-full border px-3 py-2 rounded mt-1"
//               >
//                 <option value="regular">Regular</option>
//                 <option value="offer">Offer</option>
//               </select>
//             </div>

//             {/* Product Type */}
//             <div>
//               <label className="text-sm font-medium">Product Type</label>
//               <select
//                 value={productType}
//                 onChange={(e) => setProductType(e.target.value)}
//                 className="w-full border px-3 py-2 rounded mt-1"
//               >
//                 <option value="service">Service</option>
//               </select>
//             </div>

//           </div>
//           {/* END OF 2-COLUMN GRID */}

//           {/* Description (Full Width) */}
//           <div>
//             <label className="text-sm font-medium">Description</label>
//             <textarea
//               rows="3"
//               className="w-full border px-3 py-2 rounded mt-1"
//               placeholder="Enter product description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//             ></textarea>
//           </div>

//           {/* Categories (Full Width) */}
//           <div>
//             <label className="text-sm font-medium">Product Category</label>
//             <div className="grid grid-cols-2 gap-2 mt-1">
//               {categories.map((c) => (
//                 <label key={c.id} className="flex items-center gap-2 text-sm">
//                   <input
//                     type="checkbox"
//                     checked={selectedCats.includes(c.id)}
//                     onChange={() => toggleCategory(c.id)}
//                   />
//                   {c.name}
//                 </label>
//               ))}
//             </div>
//           </div>

//           {/* Image Upload */}
//           <div>
//             <label className="text-sm font-medium">Product Image</label>
//             <input type="file" className="mt-1" onChange={handleImageUpload} />

//             {uploadLoading && <p className="text-xs text-gray-500">Uploading...</p>}

//             {image && (
//               <img src={image} alt="" className="w-20 h-20 mt-2 border rounded" />
//             )}
//           </div>

//           {/* Status */}
//           <div>
//             <label className="text-sm font-medium">Status</label>
//             <select
//               value={status}
//               onChange={(e) => setStatus(e.target.value)}
//               className="w-full border px-3 py-2 rounded mt-1"
//             >
//               <option value={1}>Active</option>
//               <option value={0}>Inactive</option>
//             </select>
//           </div>

//           <button
//             className="w-full bg-blue-600 text-white py-2 rounded"
//             disabled={loading}
//           >
//             {loading ? "Saving..." : initialData ? "Update Product" : "Add Product"}
//           </button>
//         </form>

//       </div>
//     </div>
//   );
// }




// import React, { useEffect, useState } from "react";
// import { X } from "lucide-react";

// export default function ProductModal({ isOpen, onClose, onSubmit, initialData }) {
//   const [name, setName] = useState("");
//   const [image, setImage] = useState("");
//   const [validity, setValidity] = useState("");
//   const [claims, setClaims] = useState("");
//   const [features, setFeatures] = useState("");
//   const [minValue, setMinValue] = useState("");
//   const [maxValue, setMaxValue] = useState("");
//   const [isFixed, setIsFixed] = useState(false);
//   const [isPercent, setIsPercent] = useState(false);
//   const [isRegular, setIsRegular] = useState(false);
//   const [isOffer, setIsOffer] = useState(false);
//   const [isTaxable, setIsTaxable] = useState(false);
//   const [productType, setProductType] = useState("service");
//   const [hsn, setHsn] = useState("");
//   const [mrp, setMrp] = useState("");
//   const [status, setStatus] = useState(1);

//   const [categories, setCategories] = useState([]);
//   const [selectedCats, setSelectedCats] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [uploadLoading, setUploadLoading] = useState(false);

//   // ---------------- FETCH CATEGORY LIST ----------------
//   const fetchCategories = async () => {
//     try {
//       const res = await fetch("https://goelectronix.in/api/v1/warranty/get-categories");
//       const data = await res.json();
//       setCategories(data);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // ---------------- PREFILL FOR UPDATE ----------------
//   useEffect(() => {
//     fetchCategories();

//     if (initialData) {
//       setName(initialData.name || "");
//       setImage(initialData.image || "");
//       setValidity(initialData.validity || "");
//       setClaims(initialData.claims || "");
//       setFeatures(initialData.features || "");
//       setMinValue(initialData.min_value || "");
//       setMaxValue(initialData.max_value || "");
//       setIsFixed(initialData.is_fixed || false);
//       setIsPercent(initialData.is_percent || false);
//       setIsRegular(initialData.is_regular || false);
//       setIsOffer(initialData.is_offer || false);
//       setIsTaxable(initialData.is_taxable || false);
//       setProductType(initialData.product_type || "service");
//       setHsn(initialData.hsn_or_sac || "");
//       setMrp(initialData.mrp || "");
//       setStatus(initialData.status || 1);
//       setSelectedCats(initialData.category_ids || []);
//     } else {
//       setName("");
//       setImage("");
//       setValidity("");
//       setClaims("");
//       setFeatures("");
//       setMinValue("");
//       setMaxValue("");
//       setIsFixed(false);
//       setIsPercent(false);
//       setIsRegular(false);
//       setIsOffer(false);
//       setIsTaxable(false);
//       setProductType("service");
//       setHsn("");
//       setMrp("");
//       setStatus(1);
//       setSelectedCats([]);
//     }
//   }, [initialData]);

//   if (!isOpen) return null;

//   // ---------------- IMAGE UPLOAD ----------------
//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploadLoading(true);

//     const form = new FormData();
//     form.append("file", file);
//     form.append("tag", "Product");

//     try {
//       const res = await fetch("https://goelectronix.in/api/v1/warranty/upload-file", {
//         method: "POST",
//         body: form,
//       });

//       const data = await res.json();
//       if (data?.data?.file_url) setImage(data.data.file_url);
//     } catch (err) {
//       alert("Image upload failed");
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   // ---------------- CATEGORY TOGGLE ----------------
//   const toggleCategory = (id) => {
//     if (selectedCats.includes(id)) {
//       setSelectedCats(selectedCats.filter((c) => c !== id));
//     } else {
//       setSelectedCats([...selectedCats, id]);
//     }
//   };

//   // ---------------- SUBMIT HANDLER ----------------
//   const handleSave = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const payload = {
//       name,
//       image,
//       validity: Number(validity),
//       claims: Number(claims),
//       features,
//       min_value: Number(minValue),
//       max_value: Number(maxValue),
//       is_fixed: isFixed,
//       is_percent: isPercent,
//       is_regular: isRegular,
//       is_offer: isOffer,
//       is_taxable: isTaxable,
//       product_type: productType,
//       hsn_or_sac: hsn,
//       mrp: Number(mrp),
//       status: Number(status),
//       category_ids: selectedCats,
//       company_id: 5865
//     };

//     try {
//       let url = "";
//       let method = "POST";

//       // UPDATE PRODUCT
//       if (initialData?.id) {
//         url = `https://goelectronix.in/api/v1/warranty/update-product/${initialData.id}`;
//       }
//       // CREATE PRODUCT
//       else {
//         url = "https://goelectronix.in/api/v1/warranty/create-product";
//       }

//       const res = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) throw new Error("Failed to save product");

//       onSubmit(); // refresh list + close modal

//     } catch (err) {
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
//       <div className="bg-white w-[600px] rounded-xl p-6 relative">

//         {/* Close */}
//         <button className="absolute top-3 right-3" onClick={onClose}>
//           <X size={20} />
//         </button>

//         <h2 className="text-lg font-semibold mb-4">
//           {initialData ? "Update Product" : "Add Product"}
//         </h2>

//         <form onSubmit={handleSave} className="space-y-3">

//           <div>
//             <label className="text-sm">Product Name</label>
//             <input className="w-full border px-3 py-2 rounded"
//               value={name} onChange={(e) => setName(e.target.value)} required />
//           </div>

//           <div>
//             <label className="text-sm">Upload Image</label>
//             <input type="file" onChange={handleImageUpload} />
//             {image && <img src={image} className="w-20 h-20 mt-2 border rounded" />}
//             {uploadLoading && <p className="text-xs text-gray-500">Uploading...</p>}
//           </div>

//           {/* ALL OTHER INPUTS SAME WAY */}

//           <div className="grid grid-cols-2 gap-3">
//             <input placeholder="Validity" type="number"
//               value={validity} onChange={(e) => setValidity(e.target.value)}
//               className="border px-3 py-2 rounded" />

//             <input placeholder="Claims" type="number"
//               value={claims} onChange={(e) => setClaims(e.target.value)}
//               className="border px-3 py-2 rounded" />

//             <input placeholder="Min Value" type="number"
//               value={minValue} onChange={(e) => setMinValue(e.target.value)}
//               className="border px-3 py-2 rounded" />

//             <input placeholder="Max Value" type="number"
//               value={maxValue} onChange={(e) => setMaxValue(e.target.value)}
//               className="border px-3 py-2 rounded" />

//             <input placeholder="MRP" type="number"
//               value={mrp} onChange={(e) => setMrp(e.target.value)}
//               className="border px-3 py-2 rounded" />
//           </div>

//           <textarea
//             placeholder="Features"
//             value={features}
//             onChange={(e) => setFeatures(e.target.value)}
//             className="w-full border px-3 py-2 rounded"
//           />

//           {/* Status */}
//           <select
//             value={status}
//             onChange={(e) => setStatus(e.target.value)}
//             className="border px-3 py-2 rounded w-full"
//           >
//             <option value={1}>Active</option>
//             <option value={0}>Inactive</option>
//           </select>

//           {/* Categories */}
//           <div>
//             <p className="text-sm mb-1">Select Categories:</p>
//             <div className="grid grid-cols-2 gap-2">
//               {categories.map((c) => (
//                 <label key={c.id} className="flex items-center gap-2 text-sm">
//                   <input
//                     type="checkbox"
//                     checked={selectedCats.includes(c.id)}
//                     onChange={() => toggleCategory(c.id)}
//                   />
//                   {c.name}
//                 </label>
//               ))}
//             </div>
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-blue-600 text-white py-2 rounded"
//             disabled={loading}
//           >
//             {loading ? "Saving..." :
//               initialData ? "Update Product" : "Add Product"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }


// ******************************************************************************

// import React, { useEffect, useState } from "react";
// import { X } from "lucide-react";

// export default function ProductModal({ isOpen, onClose, onSubmit, initialData }) {
//   const [name, setName] = useState("");
//   const [description, setDescription] = useState("");
//   const [status, setStatus] = useState("1");
//   const [logo, setLogo] = useState("");
//   const [categories, setCategories] = useState([]);
//   const [selectedCats, setSelectedCats] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [imageUploading, setImageUploading] = useState(false);

//   // Load categories
//   const fetchCategories = async () => {
//     try {
//       const res = await fetch(
//         "https://goelectronix.in/api/v1/warranty/get-categories"
//       );
//       const data = await res.json();
//       setCategories(data);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // Prefill if editing
//   useEffect(() => {
//     fetchCategories();

//     if (initialData) {
//       setName(initialData.name || "");
//       setDescription(initialData.description || "");
//       setStatus(initialData.status?.toString() || "1");
//       setLogo(initialData.image || "");
//       setSelectedCats(initialData.category_ids || []);
//     } else {
//       setName("");
//       setDescription("");
//       setStatus("1");
//       setLogo("");
//       setSelectedCats([]);
//     }
//   }, [initialData]);

//   if (!isOpen) return null;

//   // ----------------- Image Upload -----------------
//   const handleImageChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setImageUploading(true);

//     try {
//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("tag", "Brand");

//       const res = await fetch(
//         "https://goelectronix.in/api/v1/warranty/upload-file",
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       const data = await res.json();
//       if (data?.data?.file_url) {
//         setLogo(data.data.file_url);
//       }
//     } catch (err) {
//       alert("Image upload failed");
//     } finally {
//       setImageUploading(false);
//     }
//   };

//   // ----------------- Category Checkbox Handler -----------------
//   const toggleCategory = (id) => {
//     if (selectedCats.includes(id)) {
//       setSelectedCats(selectedCats.filter((c) => c !== id));
//     } else {
//       setSelectedCats([...selectedCats, id]);
//     }
//   };

//   // ----------------- Submit Handler -----------------
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const payload = {
//       name,
//       description,
//       image: logo,
//       category_ids: selectedCats,
//       status: Number(status),
//     };

//     try {
//       // UPDATE
//       if (initialData?.id) {
//         payload.id = initialData.id;

//         const res = await fetch(
//           "https://goelectronix.in/api/v1/warranty/update-brand",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(payload),
//           }
//         );
//         if (!res.ok) throw new Error("Update failed");
//       }

//       // CREATE
//       else {
//         const res = await fetch(
//           "https://goelectronix.in/api/v1/warranty/create-brand",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(payload),
//           }
//         );
//         if (!res.ok) throw new Error("Create failed");
//       }

//       onSubmit(); // refresh list
//     } catch (err) {
//       alert(err.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50">
//       <div className="bg-white rounded-xl w-[480px] p-6 shadow-lg relative">
//         {/* Close Button */}
//         <button
//           className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
//           onClick={onClose}
//         >
//           <X size={18} />
//         </button>

//         <h2 className="text-lg font-semibold mb-5">
//           {initialData ? "Update Brand" : "Add New Brand"}
//         </h2>

//         <form onSubmit={handleSubmit} className="space-y-4">
//           {/* Brand Name */}
//           <div>
//             <label className="block text-sm mb-1">Brand Name</label>
//             <input
//               type="text"
//               value={name}
//               required
//               onChange={(e) => setName(e.target.value)}
//               placeholder="Enter brand name"
//               className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
//             />
//           </div>

//           {/* Description */}
//           <div>
//             <label className="block text-sm mb-1">Description</label>
//             <input
//               type="text"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               placeholder="Enter description"
//               className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
//             />
//           </div>

//           {/* Upload Logo */}
//           <div>
//             <label className="block text-sm mb-1">Upload Logo</label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleImageChange}
//               className="text-sm"
//             />

//             {logo && (
//               <div className="mt-3">
//                 <img
//                   src={logo}
//                   alt="Preview"
//                   className="w-20 h-20 object-cover border rounded"
//                 />
//                 {imageUploading && (
//                   <p className="text-xs text-gray-500 mt-1">Uploading...</p>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Select Categories */}
//           <div>
//             <label className="block text-sm mb-2">Select Categories</label>

//             <div className="grid grid-cols-2 gap-2">
//               {categories.map((cat) => (
//                 <label
//                   key={cat.id}
//                   className="flex items-center gap-2 text-sm"
//                 >
//                   <input
//                     type="checkbox"
//                     checked={selectedCats.includes(cat.id)}
//                     onChange={() => toggleCategory(cat.id)}
//                   />
//                   {cat.name}
//                 </label>
//               ))}
//             </div>
//           </div>

//           {/* Status */}
//           <div>
//             <label className="block text-sm mb-1">Status</label>
//             <select
//               value={status}
//               onChange={(e) => setStatus(e.target.value)}
//               className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
//             >
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </select>
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             disabled={loading || imageUploading}
//             className="w-full bg-blue-600 text-white py-2 rounded-md text-sm hover:bg-blue-700 font-semibold"
//           >
//             {loading ? "Saving..." : initialData ? "Update Brand" : "Add Brand"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }
